const CHANNELS = [
  { bit: 1, label: "FBA", className: "bg-success" },
  { bit: 2, label: "FBM", className: "bg-warning" },
  { bit: 4, label: "eBay", className: "bg-danger" },
  { bit: 8, label: "Walmart", className: "bg-primary" },
  { bit: 16, label: "Other", className: "bg-pink" },
  { bit: 32, label: "Online Store", className: "bg-info" },
  { bit: 64, label: "LIQUIDATIONS", className: "bg-secondary" },
];

const SalesChannels = ({ channel }) => {
  const active = CHANNELS.filter((c) => (channel & c.bit) === c.bit);
  
  if (!channel || active.length === 0) {
    return <span className="badge text-dark bg-info">none</span>;
  }

  if (active.length === 1) {
    const c = active[0];
    return <span className={`badge text-dark ${c.className}`}>{c.label}</span>;
  }

  return (
    <div className="d-flex flex-wrap gap-1 justify-content-space-between">
      {active.map((c) => (
        <span key={c.bit} className={`badge text-dark ${c.className}`}>
          {c.label}
        </span>
      ))}
    </div>
  );
};

export default SalesChannels;
